import axios from 'axios'

export default {
  /* getProfile () {
    return axios.get('/jsondata/profile.json')
  }, */
  getProfile(userId) {
    return axios.get(`/api/users/${userId}`)
  },
  getUserRoles() {
    return axios.get('/jsondata/user_roles.json')
  },
  updateProfile(profile) {
    return axios.put('/api/users/profile', profile)
  },
  changePassword(passwords) {
    return axios.put('/api/users/profile/password', passwords)
  },
  releaseStudent(id) {
    return axios.put(`/api/users/students/${id}/release`)
  }
}
